import common from './common';
import Module from './module';
import Util from './lib/util';

class VolunteerForm extends Module {

    init() {
        return super.init().then(() => this.emit('init'));
    }

    main() {
        $.validator.unobtrusive.parse('.nha-volunteer-form-wrapper');
    }

    bindEvents() {
        $('#Form_SocialSecurityNumber').mask('000-00-0000');
        $('#Form_Day').mask('00');
        $('#Form_Year').mask('0000');
        $('#Form_ZipCode').mask('00000');

        NHAUtil.configureTooltips();

        $('.nha-volunteer-form-wrapper').on('click.validate focusin.validate focusout.validate keyup.validate', e => this.onFormChanged(e));

        $('.nha-volunteer-form-wrapper').on('focusout.validate', Util.debounce(e => this.onFormBlurred(e)));

        $('input[name="existingParent"]').on('click', e => {
            if (e.target.value === "yes") {
                $('.nha-volunteer-form-wrapper').hide();
                $('.nha-volunteer-portal-message').show();
            } else {
                $('.nha-volunteer-form-wrapper').show();
                $('.nha-volunteer-portal-message').hide();
            }
        });
    }

    onFormBlurred(e) {
        $(e.target).valid();

        this.onFormChanged(e);
    }

    onFormChanged(e) {
        $('.nha-form-control').each((e, el) => {
            let field = $(el);
            let group = field.closest('.nha-form-group');

            group.removeClass('nha-form-error');

            if (field.hasClass('input-validation-error') && !field.hasClass('valid')) {
                group.addClass('nha-form-error');
            }
        });

        var video = document.getElementsByName("Form.GAVolunteerVideo");
        var pdf = document.getElementsByName("Form.GAVolunteerPDF");
        var signature = document.getElementsByName("Form.Signature");

        if (video[0].checked == true && pdf[0].checked == true) {
            signature[0].disabled = false;
        } else {
            signature[0].disabled = true;
        }
    }
}

const volunteerForm = new VolunteerForm();

common.on('init', () => volunteerForm.init());

export default volunteerForm;



// WEBPACK FOOTER //
// ./wwwroot/js/app/volunteer-form.js